<template>
  <TheMenuLayout>
    <div v-if="lastSemester">
      <BaseSectionHeader>
        {{ $t('Last semester') }} - {{ lastSemester.semester }}
      </BaseSectionHeader>
      <v-row>
        <v-col cols="6" lg="3">
          <BaseNumberCard color="accent lighten-3" :title="$t('General ranking')">
            <span v-if="lastSemester.rank">
              {{ lastSemester.rank }}/{{ lastSemester.number_of_students }}
            </span>
            <span v-else>NA</span>
          </BaseNumberCard>
        </v-col>
        <v-col cols="6" lg="3">
          <BaseNumberCard color="accent lighten-3" :title="$t('Average mark')">
            <span v-if="lastSemester.average_mark">
              {{ lastSemester.average_mark.toLocaleString(undefined, { maximumFractionDigits: 2 }) }}/20
            </span>
            <span v-else>
              NA
            </span>
          </BaseNumberCard>
        </v-col>
        <v-col cols="6" lg="3">
          <BaseNumberCard color="grey lighten-3" :title="$t('Max grade')">
            <span v-if="lastSemester.min_and_max.max">
              {{ lastSemester.min_and_max.max.toLocaleString(undefined, { maximumFractionDigits: 2 }) }}/20
            </span>
            <span v-else>
              NA
            </span>
          </BaseNumberCard>
        </v-col>
        <v-col cols="6" lg="3">
          <BaseNumberCard color="grey lighten-3" :title="$t('Min grade')">
            <span v-if="lastSemester.min_and_max.min">
              {{ lastSemester.min_and_max.min.toLocaleString(undefined, { maximumFractionDigits: 2 }) }}/20
            </span>
            <span v-else>
              N/A
            </span>
          </BaseNumberCard>
        </v-col>
      </v-row>

      <v-divider class="mb-4" />

      <BaseSectionHeader>
        {{ $t('Rank') }}
      </BaseSectionHeader>

      <v-row>
        <v-col cols="12" class="max-w-800">
          <v-card rounded outlined class="pa-4">
            <BaseBarChart
              :labels="labels"
              :dataSets="dataSets"
            />
          </v-card>
        </v-col>
      </v-row>
    </div>
    <BaseEmptyState v-else>
      Vous n'avez pas encore de note enregistrée
    </BaseEmptyState>
  </TheMenuLayout>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { countBy, compact } from 'lodash';

import BaseSectionHeader from '@/components/BaseSectionHeader.vue';
import TheMenuLayout from '@/components/TheMenuLayout.vue';
import BaseNumberCard from '@/components/BaseNumberCard.vue';
import BaseBarChart from '@/components/BaseBarChart.vue';
import BaseEmptyState from '@/components/BaseEmptyState.vue';

export default {
  name: 'Rank',
  components: {
    BaseSectionHeader,
    TheMenuLayout,
    BaseNumberCard,
    BaseBarChart,
    BaseEmptyState,
  },
  data() {
    return {
      chartType: 'bar',
      labels: Array(20).fill().map((v, i) => i),
    };
  },
  created() {
    this.fetchProgression().then(() => {
      this.fetchFacultyMarks(this.lastSemester.semester);
    });
  },
  computed: {
    ...mapState(['facultyMarks']),
    ...mapGetters(['lastSemester']),
    roundedMarks() {
      return compact(this.facultyMarks.marks).map((mark) => parseInt(mark.toFixed(), 10));
    },
    dataSets() {
      const data = [];
      const counts = countBy(this.roundedMarks);
      for (let i = 0; i <= 20; i += 1) {
        data[i] = counts[i];
      }
      const backgroundColor = Array(20).fill('#003360');
      if (this.facultyMarks.my_mark) {
        const myRoundedMark = parseInt(this.facultyMarks.my_mark.toFixed(), 10);
        backgroundColor[myRoundedMark] = '#EF9A9A';
      }
      return [{
        label: 'Élèves',
        data,
        backgroundColor,
      }];
    },
  },
  methods: mapActions(['fetchFacultyMarks', 'fetchProgression']),
};
</script>

<style lang="scss" scoped>
.max-w-800 {
  max-width: 800px;
}
</style>
